
const SEA = 'SEA'
const AIR = 'AIR'
const SEA_COUNT = 40;
const AIR_COUNT = 10;

const allBoxTypes = [SEA, AIR]
const enumBoxTypes = {
    [SEA]: 'Sea',
    [AIR]: 'Air',
}

exports.allBoxTypes = allBoxTypes;
exports.enumBoxTypes = enumBoxTypes;
exports.SEA = SEA;
exports.AIR = AIR;
exports.SEA_COUNT = SEA_COUNT;
exports.AIR_COUNT = AIR_COUNT;